import messages from './messages';
import {
  EMAIL_REGULAR_EXPRESSION,
  PASSWORD_REGULAR_EXPRESSION,
} from '../../../utils/common/constants';

const emailRegex = EMAIL_REGULAR_EXPRESSION;
const passwordRegex = PASSWORD_REGULAR_EXPRESSION;
// eslint-disable-next-line max-len
const phoneRegex =
  /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;

export default (values, { formatMessage }) => {
  const errors = {};

  if (!values.givenName) {
    errors.givenNameError = formatMessage(messages.firstNameError);
  }

  if (!values.familyName) {
    errors.familyNameError = formatMessage(messages.lastNameError);
  }

  if (!values.email) {
    errors.emailError = formatMessage(messages.emptyEmailError);
  }

  if (values.email && !emailRegex.test(values.email)) {
    errors.emailError = formatMessage(messages.emailFormatError);
  }

  if (!phoneRegex.test(values.phoneNumber)) {
    errors.phoneError = formatMessage(messages.phoneNumberError);
  }

  if (!values.password) {
    errors.passwordError = formatMessage(messages.passwordError);
  }

  if (values.password && !passwordRegex.test(values.password)) {
    errors.passwordError = formatMessage(messages.passwordLengthError);
  }
  return errors;
};
